import { useAuthContext } from '../../auth';
import { routes } from '../../routes';
import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';

export const Footer = () => {
  const { user } = useAuthContext();

  // Obfuscated email to prevent scraping
  const getEmail = () => ['hello', 'mailcrunch.io'].join('@');

  return (
    <footer className="relative bg-gray-900 py-16 px-6 overflow-hidden">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />

      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand column */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <Wordmark className="h-7 w-auto" fill="white" />
            </div>
            <p className="text-gray-400 leading-relaxed max-w-sm mb-6">
              The email template builder for regulated industries. One template, every variant, zero mistakes.
            </p>
            {user ? (
              <Link
                to="/orgs"
                className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-medium transition-colors"
              >
                Go to Dashboard
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            ) : (
              <Link
                to={routes.login.getPath()}
                className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-medium transition-colors"
              >
                Get started free
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            )}
          </div>

          {/* Product column - links scroll to sections on landing page */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">
              Product
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${getEmail()}?subject=Mailcrunch Inquiry`}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact Sales
                </a>
              </li>
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${getEmail()}`}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {getEmail()}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Mailcrunch. All rights reserved.
          </p>
          {/* Hidden until legal pages are ready
          <div className="flex items-center gap-6">
            <a href="/privacy" className="text-gray-500 hover:text-gray-400 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="text-gray-500 hover:text-gray-400 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
          */}
        </div>
      </div>
    </footer>
  );
};
